import { Box, Paper, Typography } from '@mui/material';
import { GridContainer } from 'components/shared/Grid/Grid.components';

interface Props {
  title: string;
  children: React.ReactNode;
  hasContainer?: boolean;
  containerVariant?: 'elevation' | 'outlined';
  containerElevation?: number;
}

const FormSubSection = ({
  title,
  children,
  hasContainer = true,
  containerVariant = 'outlined',
  containerElevation = 3
}: Props) => {
  if (hasContainer) {
    return (
      <Paper
        sx={{ p: 2 }}
        variant={containerVariant}
        elevation={containerVariant === 'elevation' ? containerElevation : 0}
      >
        <Typography variant="h5" sx={{ mb: 2 }}>
          {title}
        </Typography>
        <GridContainer sx={{ my: 2 }}>{children}</GridContainer>
      </Paper>
    );
  }

  return (
    <Box sx={{ mb: 5 }}>
      <Typography variant="h5">{title}</Typography>
      <GridContainer sx={{ my: 0 }}>{children}</GridContainer>
    </Box>
  );
};

export default FormSubSection;
